import React from "react"

const Tags = ({ children, className, isSpan, ...rest }) => {
    className = `tags${className ? " " + className : ""}`
    if (isSpan) {
        return (
            <span className={className} {...rest}>
                {children}
            </span>
        )
    }
    return (
        <div className={className} {...rest}>
            {children}
        </div>
    )
}

export default Tags
